import React from 'react'
import { Field, FieldArray } from 'redux-form'
import { compose } from 'recompose'

import { has, isObject } from 'lodash'

import { translate, forms, utils } from 'parking-react-common'

import { routing, parkingLots } from '../redux'

import form from '../components/Form'
import Panel from '../components/Panel'
import FormContainer from '../components/FormContainer'
import FormButtons from '../components/FormButtons'
import ErrorMessage from '../components/ErrorMessage'
import Input from '../components/Input'
import Switch from '../components/Switch'
import Select from '../components/Select'
import RadioGroup from '../components/RadioGroup'
import TimePickerInput from '../components/TimePickerInput'
import SchedulesListForm from '../components/SchedulesListForm'
import FixedDurationsListForm from '../components/FixedDurationsListForm'
import SpecialIntervalsListForm from '../components/SpecialIntervalsListForm'
import {
    NumberDurationField,
    formatNumberDurationField,
    parseNumberDurationField
} from '../components/NumberDurationField'

const ScheduleForm = (props) => {
    const { currentValues, errors, t } = props
    const hasFixedDurations = currentValues.pay_before && currentValues.hasFixedDurations

    return (
        <div>
            <Panel
                title={ t('Schedule and Pricing') }
                hasTable
                withDivider
            >
                <FormContainer isHorizontal>
                    <Field
                        name="currency"
                        label={ t('Currency') }
                        component={ Select }
                        options={ utils.label('parking-lots.currency') }
                        disabled
                        isHorizontal
                    />
                    <Field
                        name="pay_before"
                        label={ t('Pay Before') }
                        component={ Switch }
                        isHorizontal
                    />
                    { currentValues.pay_before && (
                        <Field
                            name="hasFixedDurations"
                            label={ t('Fixed Priced Intervals') }
                            component={ Switch }
                            isHorizontal
                        />
                    ) }
                    <Field
                        name="schedule"
                        label={ t('Schedule Type') }
                        component={ RadioGroup }
                        options={ {
                            singlePrice    : parkingLots.getScheduleName(parkingLots.SCHEDULE_TYPES.singlePrice),
                            weeklySchedule : parkingLots.getScheduleName(parkingLots.SCHEDULE_TYPES.weeklySchedule),
                            customSchedule : parkingLots.getScheduleName(parkingLots.SCHEDULE_TYPES.customSchedule)
                        } }
                        isHorizontal
                    />
                    { currentValues.schedule === parkingLots.SCHEDULE_TYPES.singlePrice && !hasFixedDurations && (
                        <Field
                            name="singlePrice"
                            label={ t('Price') }
                            placeholder={ t('Price') }
                            component={ Input }
                            isHorizontal
                        />
                    ) }
                    {
                        has(errors, 'opening_intervals') && !isObject(errors.opening_intervals)
                        && <ErrorMessage error={ errors.opening_intervals } />
                    }
                </FormContainer>
            </Panel>
            { hasFixedDurations && (
                <FieldArray
                    name="fixed_durations"
                    component={ FixedDurationsListForm }
                    currentValues={ currentValues.fixed_durations }
                />
            ) }
            { currentValues.schedule !== parkingLots.SCHEDULE_TYPES.singlePrice && (
                <FieldArray
                    name="opening_intervals"
                    component={ SchedulesListForm }
                    type={ currentValues.schedule }
                    currentValues={ currentValues.opening_intervals }
                    withPricing={ !hasFixedDurations }
                />
            ) }
            <FieldArray
                name="specialIntervals"
                component={ SpecialIntervalsListForm }
            />
            <Panel
                title={ t('Limitations') }
                hasTable
                withDivider
            >
                <FormContainer isHorizontal>
                    { hasFixedDurations
                        ? (
                            <Field
                                name="min_time"
                                label={ t('Minimum Stay') }
                                isHorizontal
                                component={ NumberDurationField }
                                parse={ parseNumberDurationField }
                                format={ formatNumberDurationField }
                            />
                        ) : (
                            <Field
                                name="min_time"
                                label={ t('Minimum Stay') }
                                placeholder={ t('Minimum Stay') }
                                component={ TimePickerInput }
                                isHorizontal
                            />
                        )
                    }
                    { hasFixedDurations
                        ? (
                            <Field
                                name="max_time"
                                label={ t('Maximum Stay') }
                                isHorizontal
                                component={ NumberDurationField }
                                parse={ parseNumberDurationField }
                                format={ formatNumberDurationField }
                            />
                        ) : (
                            <Field
                                name="max_time"
                                label={ t('Maximum Stay') }
                                placeholder={ t('Maximum Stay') }
                                component={ TimePickerInput }
                                isHorizontal
                            />
                        )
                    }
                    <Field
                        name="min_cost"
                        label={ t('Minimum Cost') }
                        placeholder={ t('Minimum Cost') }
                        component={ Input }
                        isHorizontal
                    />
                    <Field
                        name="max_cost"
                        label={ t('Maximum Cost') }
                        placeholder={ t('Maximum Cost') }
                        component={ Input }
                        isHorizontal
                    />
                </FormContainer>
            </Panel>
            <FormButtons
                onCancel={ () => {
                    routing.push(routing.routeFor('parkingLots', {
                        id     : currentValues.id,
                        tab    : 'schedule',
                        action : null
                    }))
                } }
                { ...props }
            />
        </div>
    )
}

ScheduleForm.propTypes = forms.propTypes

export default compose(
    translate(),
    form({ id: forms.parkingLot.id })
)(ScheduleForm)
